// File: frontend/src/components/MedicalDisclaimer.jsx
// Reusable medical/AI disclaimer banner for health-related screens.

import React from 'react';

const VARIANTS = {
  ai: 'This content is generated by AI and is for informational purposes only. It does not constitute medical advice, diagnosis, or treatment. Always consult a qualified healthcare provider before making health decisions.',
  health: 'Health metrics and recommendations are based on general guidelines and may not apply to your specific situation. Consult your healthcare provider for personalized medical advice.'
};

export default function MedicalDisclaimer({ variant = 'ai' }) {
  return (
    <div className="medical-disclaimer">
      <p>{VARIANTS[variant] || VARIANTS.ai}</p>
    </div>
  );
}
